import { DialogTitle, DialogTitleProps, styled } from "@mui/material";
import React from "react";

type PlatformDialogTitleProps = DialogTitleProps & {
  destructive: boolean;
};

export const PlatformDialogTitle = styled(DialogTitle, {
  shouldForwardProp: (prop) => prop !== "destructive",
})<PlatformDialogTitleProps>(({ theme, destructive }) => {
  // TODO: I am a one off that cannot use the core global
  const LAYOUT_TOGGLE_STORAGE_KEY = "ENABLE_ALTERNATE_LAYOUT";
  const useAlternateLayout = localStorage.getItem(LAYOUT_TOGGLE_STORAGE_KEY) === "true";

  return {
    justifyContent: "space-between",
    alignItems: "center",
    display: "flex",
    flex: "1 1 auto",
    flexWrap: "nowrap",
    fontSize: theme.typography.h4?.fontSize,
    fontWeight: theme.typography.h4?.fontWeight,
    lineHeight: theme.typography.h4?.lineHeight,
    "&.MuiDialogTitle-root": useAlternateLayout
      ? {
          paddingRight: "32px",
        }
      : undefined,
    ...(destructive
      ? {
          backgroundColor: useAlternateLayout
            ? theme.palette.background.paper
            : theme.palette.error.main,
          color: useAlternateLayout
            ? theme.palette.text.primary
            : theme.palette.secondary.contrastText,
        }
      : {
          backgroundColor: useAlternateLayout
            ? theme.palette.background.paper
            : theme.palette.primary.light,
          color: useAlternateLayout
            ? theme.palette.text.primary
            : theme.palette.secondary.contrastText,
        }),
  };
}) as React.ComponentType<PlatformDialogTitleProps>;
